const FilterLevel1 = (props) => {
  const { activeL1, category, handleFilterChange } = props;

  return (
    <li
      className={activeL1 == category.id ? 'active' : ''}
      data-id={category.id.toString()}
      onClick={(e) => handleFilterChange(e)}
    >
      {category.name}
      <span className='tick'></span>
    </li>
  );
};

export default FilterLevel1;
